import React from 'react';

export const useWillUnmountRef = () => {
  const willUnmountRef = React.useRef(false);

  React.useEffect(() => {
    return () => {
      willUnmountRef.current = true;
    };
  }, []);

  return willUnmountRef;
};
